/** A stored ISO purchase date in the reader's language, read as local midnight so it never shifts a day. */
export const formatPurchaseDate = (isoDate: string, language: string): string =>
  new Date(`${isoDate}T00:00:00`).toLocaleDateString(language, { day: 'numeric', month: 'short', year: 'numeric' });

/** One label from the projected locale map: the selected language, its primary subtag, then English. */
export function displayFieldLabel(labels: Record<string, string> | undefined, language: string): string {
  if (!labels) return '';
  const primary = language.split('-')[0] ?? language;
  for (const key of [language, primary, 'en']) {
    const text = labels[key]?.trim();
    if (text) return text;
  }
  return '';
}

/** A projected display field, with dates in the reader's language. */
export function formatDisplayField(field: { format: 'text' | 'date'; value: string }, language: string): string {
  switch (field.format) {
    case 'text':
      return field.value;
    case 'date':
      return formatPurchaseDate(field.value, language);
    default: {
      const unexpected: never = field.format;
      return unexpected;
    }
  }
}
